
import SetSnowflakeCredentialsDialog from '@/components/Settings.CloudAccounts/Snowflake/SetSnowflakeCredentialsDialog.vue';
import PostCloudAccountButton from '@/components/Settings.CloudAccounts/PostCloudAccountButton.vue';
export default {
    components: { SetSnowflakeCredentialsDialog, PostCloudAccountButton },
    props: {
        value: Boolean,
    },
};
